import script from "./devotion-categories-page.vue?vue&type=script&setup=true&lang=js"
export * from "./devotion-categories-page.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__